import React from 'react'

type Props = {
    children: React.ReactNode
    onClick?: () => void
}

export function BlockQuote({ children, onClick }: Props) {
    return (
        <blockquote className={'AppCore__ui__BlockQuote'}>
            {onClick ? <a onClick={onClick}>{children}</a> : children}
        </blockquote>
    )
}
